var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-4 col-lg-3"},[_c('NavigationComponent')],1),_c('div',{staticClass:"col-12 col-sm-12 col-md-8 col-lg-9"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }